import { Accordion } from '@components/atoms/Accordion'
import { ConfigurationsLayout } from '@components/configurations/ConfigurationsLayout'
import { EmailTemplateForm, type EmailTemplate } from '@components/configurations/EmailTemplateForm'
import { SettingsAccordionItem } from '@components/configurations/SettingsAccordionItem'
import { SettingsCard } from '@components/configurations/SettingsCard'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('configurations.account_emails')

const ACTION = '/app/settings/account_emails'

export type AccountEmailsShowProps = { values: Record<string, string> }

const INVITATION_VARIABLES = {
  inviter: '[%inviter.name_or_email%]',
  invitee: '[%invitee.name_or_email%]',
  invitation_link: '[%invitation_url%]',
}

const LEADER_INVITATION_VARIABLES = {
  inviter: '[%inviter.name_or_email%]',
  invitee: '[%invitee.name_or_email%]',
  group_names: '[%supporter_group_names%]',
  invitation_link: '[%invitation_url%]',
}

const template = (id: string, prefix: string, variables: Record<string, string>): EmailTemplate => ({
  id,
  keys: [`${prefix}_SUBJECT`, `${prefix}_CONTENT`],
  richTextKey: `${prefix}_CONTENT`,
  variables,
})

const TEMPLATES = [
  template('admin_invitation', 'ADMIN_INVITATION', INVITATION_VARIABLES),
  template('captain_invitation', 'CAPTAIN_INVITATION', LEADER_INVITATION_VARIABLES),
  template('vice_captain_invitation', 'VICE_CAPTAIN_INVITATION', LEADER_INVITATION_VARIABLES),
  template('reset_password', 'RESET_PASSWORD', {
    user_name: '[%user.name_or_email%]',
    reset_password_link: '[%reset_password_url%]',
  }),
  template('unlock_account', 'UNLOCK_ACCOUNT', {
    user_name: '[%user.name_or_email%]',
    unlock_link: '[%unlock_account_url%]',
  }),
]

export default function AccountEmailsShow({ values }: AccountEmailsShowProps) {
  return (
    <ConfigurationsLayout>
      <SettingsCard heading={t('templates.heading')}>
        <Accordion type="multiple" className="tw:px-5">
          {TEMPLATES.map((template) => (
            <SettingsAccordionItem key={template.id} value={template.id} trigger={t(`templates.${template.id}`)}>
              <EmailTemplateForm action={ACTION} values={values} template={template} t={t} />
            </SettingsAccordionItem>
          ))}
        </Accordion>
      </SettingsCard>
    </ConfigurationsLayout>
  )
}
